import translationsJSON from "./translations.json";

export const translations = translationsJSON;
export let currentLang = localStorage.getItem("lang") || "en";

export function setLanguage(lang) {
  currentLang = lang;
  localStorage.setItem("lang", lang);
  applyTranslations();
}

export function applyTranslations() {
  document.querySelectorAll("[data-i18n]").forEach(el => {
    const key = el.getAttribute("data-i18n");
    const text = key.split(".").reduce((obj, k) => obj?.[k], translations[currentLang]);
    if (text) {
      // Always textContent - never innerHTML (XSS-safe by construction)
      el.textContent = Array.isArray(text) ? text.join(" ") : text;
    }
  });
}

// Helper function to get translation by key
export function t(key) {
  return key.split(".").reduce((obj, k) => obj?.[k], translations[currentLang]) || key;
}

// Initialize on page load
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', applyTranslations);
}
